export enum SiderMenuItems {
  Home = 'Головна',
  Sites = 'Сайти',
  SiteGroups = 'Групи Сайтів',
  Domains = 'Домени',
  DomainRegistrars = 'Реєстратори домену',
  Hostings = 'Хостинги',
  DomainsApi = 'API доменів',
  ProxyServers = 'Проксі-сервери',
  DnsRecords = 'DNS записи',
  DomainsApiCloudflare = 'Cloudflare',
  DomainsApiSearchConsole = 'Search Console',
}
